import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Notifications.jsx
 * ---------------------------------------------
 * Компонент уведомлений.
 * Оповещает менеджера о принятых офферах (статус "В работе"), отображает их количество.
 *
 * Пропсы:
 * - offerId: string | number — идентификатор оффера (комнаты)
 * - requestId: string | number — идентификатор запроса
 * - userId: string | number — текущий пользователь (для возможной логики)
 * - managerUserId: string | number — идентификатор Менеджера (сообщения от него справа)
 *
 * Зависимости:
 * - axios (для примера API)
 */

function Notifications({ id_cs_manager }) {

    const [quantityNot, setQuantityNot] = useState([]);

    // Подтягиваем сообщения при монтировании/смене offerId
    useEffect(() => {
        let ignore = false;
        async function fetchMessages() {
            try {
                const res = await axios.get(`/api/notifications`);
                console.log("Ответ от /api/notifications:", res.data);
                if (!ignore) setQuantityNot(Array.isArray(res.data) ? res.data : []);
            } catch (e) {
                console.error("Ошибка получения количества принятых предложений:", e);
            }
        }
        fetchMessages();
        return () => {
            ignore = true;
        };
    }, [id_cs_manager]);

    return (
        <>
            {quantityNot[0] && quantityNot[0].count > 0 && (
                <span className="notification-badge">
                    {quantityNot[0].count}
                </span>
            )}
        </>
    );
}

export default Notifications;